import { Injectable } from "@angular/core";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom } from "rxjs";
import { Accounts } from "../models/accounts.model";
import { AccountsApi } from "./accounts.api";

interface AccountsTypeaheadOptions {
    roles?: string[];
}

@Injectable()
export class AccountsTypeaheadApi extends NiceAsyncTypeaheadProvider<Accounts> {
    public override readonly resource = "accounts";
    private readonly pageSize = 15;

    constructor(private api: AccountsApi) {
        super();
    }

    public override async getById(id: number): Promise<Accounts> {
        return lastValueFrom(this.api.getById(id));
    }

    public override async search(
        searchQuery: string,
        page: number,
        options?: AccountsTypeaheadOptions
    ): Promise<NiceAsyncTypeaheadSearchResult<Accounts>> {
        const items = await lastValueFrom(
            this.api.search({
                searchQuery,
                page,
                pageSize: this.pageSize,
                ...options
            })
        );

        return {
            items,
            nextPage: items.length === this.pageSize ? page + 1 : null
        };
    }

    public override format(item: Accounts): string {
        return item.fullName ?? "";
    }
}
